/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { HelpModalComponentArgs } from 'cio/components/help-modal';

import { FlyKeyboardEvent } from '@customerio/fly-components/types/fly-components/events';
import { isEmpty } from '@ember/utils';
import ObjectTypesService from 'cio/services/object-types';

export default class ObjectsRequestAccessForm extends Component<HelpModalComponentArgs> {
  @service('objectTypes') objectTypesService!: ObjectTypesService;

  @tracked feedback = '';

  get canSubmit() {
    return !isEmpty(this.feedback) && this.objectTypesService.canConfigureObjectTypes && !this.args.isSubmitting;
  }

  @action
  onSubmitAction(e: Event) {
    if (!this.canSubmit) {
      return;
    }

    e.preventDefault();

    this.args.onSubmit(
      {
        criticism: 'What do you plan to do with Custom Objects?',
        praise: this.feedback,
      },
      true,
    );
  }

  @action
  updateFeedback(evt: FlyKeyboardEvent<HTMLTextAreaElement>) {
    this.feedback = evt.target.value;
  }
}
